
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../util.js';
import { Toast } from 'antd-mobile/lib';
import {verifyRegisterPhone} from '../../action/investmentAction.js';
import {registerAccount, getCapcha, getMobileCaptcha} from '../../action/loginAction.js';
import { protocolCode } from '../../BankCode';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';
import { goHome } from '../../common.js';
let intervalId = null;
let requestId = '';

/*
register?enterType=Investment/Register&inviteCode=手机号
*/

class Register extends Component{
  state={
    mobileNumber: '',
    password: '',
    mobileDynamicCode: '',
    isRequestingVerifyCode: false,
    countdown: 120,
    isSelected: false,
    flag: false,
    invitationCode: this.props.location.query.inviteCode ? (/^1[34578]\d{9}$/.test(this.props.location.query.inviteCode) ? this.props.location.query.inviteCode : "") : window.localStorage.getItem("inviteCode"),
    invitationCodeFlag: true,
    enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
    captchaCode: "",
    serverCapchaCode: "",
    imageBase64: ""
  }

  componentWillMount() {
    // window.localStorage.setItem("inviteCode", '18679933878');
    console.log(window.localStorage.getItem("inviteCode"))
    document.title = "注册";
    if(this.props.location.query.enterType === "Register") {

    }else{
      this.setState({
        mobileNumber: window.localStorage.getItem("register_phoneNo"),
        password: window.localStorage.getItem("register_password")
      });
    }
  }
  componentDidMount(){
     this.getPicCaptchaFun();
  }
  componentWillUnmount(){
    requestId = '';
    this.setState({
      flag: false
    });
    if(intervalId) {
      clearInterval(intervalId);
    }
  }

  handleVerify = () => {
    if(!this.state.mobileDynamicCode || !this.state.mobileNumber ){
      Toast.info('请输入信息', 2);
      return;
    }
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(!this.state.password){
      let toast = Toast.info('请输入密码', 2);
      return;
    }
    if(!/\S/.test(this.state.captchaCode)){
      Toast.info('请输入图形验证码', 2);
      return ;
    }
    if(requestId === '' || !requestId){
      Toast.info('请先申请手机验证码', 2);
      return ;
    }
    if(!this.state.isSelected){
      Toast.info('同意协议后才能注册', 2);
      return ;
    }
    if(this.state.invitationCode && !(/^1[0123456789]\d{9}$/.test(this.state.invitationCode))){
      Toast.info('用户邀请码不合规', 2);
      return ;
    }
    // if(this.state.invitationCode == this.state.mobileNumber){
    //   Toast.info('用户邀请码不能与注册的手机号一致', 2);
    //   return ;
    // }
    let verifyParam = {
      requestId : requestId,
      mobileNo : this.state.mobileNumber,
      captchaText : this.state.mobileDynamicCode,
      password: Util.encrypt(this.state.password),
      invitationCode: this.state.invitationCode ? this.state.invitationCode : ""
    }
    this.setState({
      flag: true
    })
    this.props.dispatch(registerAccount(verifyParam, ()=>{this.verifySuccess()}, (msg)=>this.verifyError(msg)));
  }

  verifySuccess = async () => {
    this.setState({
      flag: false
    });
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    // if(route) {
    //   hashHistory.go(route - window.history.length);
    // }else {
    //   hashHistory.goBack();
    // }
    // setTimeout(() => {
    //   if(callback) {
    //     callback();
    //   }
    // }, 100);
    if(this.state.enterType == "Register"){
      goHome("Investment");
      // hashHistory.push({
      //   pathname: "/",
      //   state: {
      //     route: route,
      //     callback: callback
      //   },
      //   query:{
      //     enterType:"Investment"
      //   }
      // })
    }else if(this.state.enterType == "Answer" || this.state.enterType == "activity"){
      hashHistory.push({
        pathname:'/CertificationUpload',
        state:{
          phoneNo:this.state.mobileNumber,
        },
        query: {enterType:this.state.enterType,
          activityId:this.props.location.query.activityId
        }
      })
    }else{
      hashHistory.go(-2);
    }
  }
  verifyError = (msg) => {
    this.setState({
      flag: false
    })
    Toast.info(msg, 2);
  }
  verifyRegisterPhoneSuc = (mobileNumber) => {
    let params = {
      mobileNo: this.state.mobileNumber,
      token: this.state.serverCapchaCode,
      captchaCode: this.state.captchaCode.toUpperCase()
    }
    this.props.dispatch(getMobileCaptcha(params, (suc) =>{
      requestId = suc;
      this.makeInterval();
    }, (err) => {
      Toast.info(err.code, Util.ToastTime);
      requestId = "";
      this.setState({
        captchaCode: ""
      });
      this.getPicCaptchaFun();
    }));
  }

  verifyRegisterPhoneErr = (msg) => {
    Toast.info(msg, 2);
    if(intervalId)
      clearInterval(intervalId);
    intervalId = null;
    this.setState({
      isRequestingVerifyCode: false
    });
  }

  handleWaitingForVerifyDynamicCode = () => {
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(!/\S/.test(this.state.captchaCode)){
      Toast.info('请输入图形验证码', 2);
      return ;
    }
    this.props.dispatch(verifyRegisterPhone({mobileNo: this.state.mobileNumber}, (mobileNumber)=>{this.verifyRegisterPhoneSuc(mobileNumber)}, (msg)=>{this.verifyRegisterPhoneErr(msg)}));
  }

  makeInterval = () => {
    let countNum = 119;
    this.setState({isRequestingVerifyCode: true, countDown: countNum}, ()=>{
      intervalId = setInterval(() => {
        countNum--;
        if(countNum < 0){
          cancelTimeOut();
          this.setState({
            isRequestingVerifyCode: false
          });
        }
        this.setState({
          countDown: countNum
        })
      }, 1000);
      const cancelTimeOut = () => {
        if(intervalId)
          clearInterval(intervalId);
        intervalId = null;
      }
    });
  }

  handleJumpToProtocol = (title) => {
    let code=protocolCode[title];
    hashHistory.push({
        pathname:'/WebView',
        state:{name:title,code:code},
        query: {code:code}
    })
  }

  changePhoneNo = (event) => {
    this.setState({
      mobileNumber: event.target.value
    });
    window.localStorage.setItem("register_phoneNo", event.target.value);
  }

  clearPhoneNo = () => {
    this.setState({
      mobileNumber: ""
    });
    window.localStorage.setItem("register_phoneNo", "");
  }

  changePassWord = (event) => {
    this.setState({
      password: event.target.value
    });
    window.localStorage.setItem("register_password", event.target.value);
  }

  changeTxCode = (event) => {
    this.setState({
      captchaCode: event.target.value
    });
  }

  clearPassWord = () => {
    this.setState({
      password: ""
    });
    window.localStorage.setItem("register_password", "");
  }

  clearTxCode = () => {
    this.setState({
      captchaCode: ""
    });
  }

  changeCkCard = (event) => {
    this.setState({
      mobileDynamicCode: event.target.value
    });
  }

  goBack = () => {
    hashHistory.goBack();
  }

  toggleInvitation = () => {
    this.setState({
      invitationCodeFlag: !this.state.invitationCodeFlag
    });
  }

  //获取图形验证码
  getPicCaptchaFun = () => {
    this.props.dispatch(getCapcha((token, base64) => {
      this.setState({
        imageBase64: base64,
        serverCapchaCode: token
      });
    }, () => {

    }));
  }

  render(){
    let { mobileNumber, password, mobileDynamicCode, captchaCode, imageBase64 } = this.state;
    console.log(this.props.location.query,"locationlocationlocation")
    return (
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              {
               this.state.enterType === "Register" ? <span></span> : <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
              }
            </div>
            <div>
              <span>注册</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 25,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90}}>手机号码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete='off' style={{WebkitFlex: 1, fontSize: 14}} onChange={this.changePhoneNo} value={mobileNumber} type="text"  placeholder="请输入手机号码" /> 
            <img onClick={this.clearPhoneNo}  alt="" style={{height: 40, width: 40, marginRight: 0}} src={require("../../img/login_input_cancel.png")} />
           </div>
          </div>
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90}}>登录密码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete="off" style={{WebkitFlex: 1, fontSize: 14}} onChange={this.changePassWord} value={password} type="password"  placeholder="请输入6-8位登录密码" /> 
            <img onClick={this.clearPassWord}  alt="" style={{height: 40, width: 40, marginRight: 0}} src={require("../../img/login_input_cancel.png")} />
           </div>
          </div>
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90}}>图形验证码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete="off" style={{WebkitFlex: 1, fontSize: 14}} onChange={this.changeTxCode} value={captchaCode}  placeholder="请输入图形验证码" /> 
            <div onClick={this.getPicCaptchaFun} style={{position: "absolute", right: 40, background: "rgba(255, 255, 255, 1)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", color: "rgba(177, 46, 44, 1)"}}>
              <img alt="图片验证码" style={{width: 63,height: 27}} src={`data:image/png;base64,${imageBase64}`}/>
            </div>
            <img onClick={this.clearTxCode}  alt="" style={{height: 40, width: 40, marginRight: 0}} src={require("../../img/login_input_cancel.png")} />
           </div>
          </div>
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90}}>手机动态码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <div style={{WebkitFlex: 1, paddingRight: 10}}><input autocomplete="off" style={{fontSize: 14, width: "100%"}} onChange={this.changeCkCard} value={mobileDynamicCode} type="text"  placeholder="请输入手机动态码" /></div> 
            {
                this.state.isRequestingVerifyCode ? 
                <div style = {{
                  backgroundColor: '#d8dbdd',
                  height: 27,
                  borderRadius: 13,
                  paddingLeft: 10,
                  paddingRight:10,
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex",
                  marginRight: 10,
                  width: 110
                }}>
                  <span style = {{color: "#5b6370", fontSize: 13}}>{this.state.countDown}秒后重发</span>
                </div>
                :
                <div style={{"whiteSpace": "nowrap", width: 110, textAlign: "right", paddingRight: 13}}>
                  <span  onClick = {this.handleWaitingForVerifyDynamicCode} style = {{
                    color: '#fa063a',
                    fontSize: 13
                  }} >获取验证码</span>
                </div>
              }         
           </div>
          </div>
          <div style={{height: 45, paddingRight: 13, paddingLeft: 13}}>
            <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitJustifyContent: "flex-end", WebkitFlexDirection: "row", height: "100%"}}>
              <div style={{width: 120}}>
                <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "flex-end"}} onClick={this.toggleInvitation}>
                  <span style = {{color: '#3a3e47', marginLeft: 13, fontSize: 13}}>我有邀请码</span>
                  {
                    this.state.invitationCodeFlag ?
                    <img style={{width: 30, height: 30}} src={require('../../img/arrowBm2@4x.png')} />
                    :
                    <img style={{width: 30, height: 30}} src={require('../../img/arrowBm@4x.png')} />
                  }
                </div>
              </div>
            </div>
          </div>
          {
            this.state.invitationCodeFlag ?
            <div style = {{
              width:'auto',
              height: 45,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border: "1px solid #eaeded",
              display: "-webkit-flex"
            }}>
              <span style = {{color: '#3a3e47', marginLeft: 13, fontSize: 14, width: 80}}>邀请码</span>
              <div style = {{
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                WebkitFlex: 1,
                display: "-webkit-flex"
              }}>
                <input autocomplete="off" type="text" style = {{WebkitFlex: 1, fontSize: 13, display: "-webkit-flex"}} placeholder = {'(非必填) 请输入推荐人手机号码'} value = {this.state.invitationCode} onChange = {(event)=>this.setState({invitationCode: event.target.value})}/>
                <div onClick = {()=>{this.setState({invitationCode: ''})}}>
                  <img style={{marginRight: -2, width: 44, height: 44}} src={require('../../img/login_input_cancel.png')} />
                </div>
              </div>
            </div>
            :
            null
          }
          <div style = {{
              WebkitFlexDirection: 'row',
              WebkitJustifyContent: 'center', 
              marginTop: 15,
              marginLeft: 13,
              marginRight: 13,
              display: "-webkit-flex"
          }}>
            <div onClick = {()=>{this.setState({isSelected: !this.state.isSelected})}}>
            {
              this.state.isSelected ? 
              <img style={{
                height: 28,
                width: 28,
                marginTop: -2,
                marginLeft: -7,
                marginRight: 5
              }} src={require('../../img/protocol_selected.png')} />
              :
              <img style={{
                height: 28,
                width: 28,
                marginTop: -2,
                marginLeft: -7,
                marginRight: 5
              }} src={require('../../img/square.png')} />
            }
            </div>
            <span style = {{
              marginTop: 3,
              marginLeft: -7,
              WebkitFlex: 1,
              color: '#a1a7b2',
              fontSize: 12,
              lineHeight: "20px"
            }}>我已阅读并同意<span style = {{color: '#fa063a'}} onClick = {()=>{this.handleJumpToProtocol('华夏财富电子交易服务协议')}}>《华夏财富电子交易服务协议》</span><span style = {{color: '#fa063a'}} onClick = {()=>{this.handleJumpToProtocol('投资人权益须知')}}>《投资人权益须知》</span><span style = {{color: '#fa063a'}} onClick = {()=>{this.handleJumpToProtocol('华夏财富用户隐私政策')}}>《华夏财富用户隐私政策》</span>和<span style = {{color: '#fa063a'}} onClick = {()=>{this.handleJumpToProtocol('电子签名约定书')}}>《电子签名约定书》</span></span>
          </div>
          <div  style = {{
            marginTop: 15,
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20
          }}  onClick = {this.state.mobileDynamicCode && this.state.mobileNumber && this.state.password && this.state.isSelected ? this.handleVerify : null }>
            <div style = {{backgroundColor: this.state.mobileDynamicCode && this.state.mobileNumber && this.state.password && this.state.isSelected ? '#fa063a' : '#afb0b2' ,WebkitAlignItems: 'center',WebkitJustifyContent: 'center',height: 40,borderRadius: 20,WebkitFlexDirection: 'row',display: "-webkit-flex"}}>
              <span style = {{color: '#ffffff', fontSize: 15}}>注册</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(Register);


// WEBPACK FOOTER //
// ./src/components/login/Register.js